import { createUseStyles } from 'react-jss'
import { blue, lightBlue, lightGrey, mediumGrey, trafficGreenDark } from '../../styles/const/colors'
import { defaultBorderRadius } from '../../styles/const/common'

const getBackgroundColor = ({ isEnabled, isSolid }) => {
  if (isEnabled && isSolid) {
    return blue
  }

  if (isEnabled && !isSolid) {
    return lightBlue
  }

  return lightGrey
}

const getBorderColor = ({ isEnabled, isSolid }) => {
  if (isSolid) {
    return 'transparent'
  }

  if (isEnabled) {
    return trafficGreenDark
  }

  if (!isEnabled) {
    return mediumGrey
  }
}

const useStyles = createUseStyles({
  toggleContainer: {
    display: 'flex',
    alignItems: 'center',
    padding: data => (data.isBig ? '3px 4px' : 2),
    justifyContent: data => (data.isEnabled ? 'flex-end' : 'flex-start'),
    background: ({ isEnabled, isSolid }) => getBackgroundColor({ isEnabled, isSolid }),
    borderRadius: defaultBorderRadius,
    border: ({ isEnabled, isSolid }) => `1px solid ${getBorderColor({ isEnabled, isSolid })}`,
    height: data => (data.isBig ? 24 : 17),
    width: data => (data.isBig ? 46 : 30),
    cursor: 'pointer',
    flexShrink: 0
  },

  toggleBtn: {
    display: 'inline-block',
    border: ({ isEnabled, isSolid }) => `1px solid ${getBorderColor({ isEnabled, isSolid })}`,
    background: '#fff',
    borderRadius: defaultBorderRadius,

    height: data => (data.isBig ? 18 : 11),
    width: data => (data.isBig ? 18 : 11)
  }
})

export default useStyles
